// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"d48cf1c2","122":"2c168550","167":"7075148e","411":"b09e851c"}[chunkId] + ".chunk.css";
};